export const GET_TRANSLATIONS_URL = "/payment/api/translations/:transactionId";
export const GET_FORM_TEMPLATE_URL = "/payment/api/formTemplate/:transactionId";
export const SUBMIT_TRANSACTION_URL = "/payment/initialize/api/:transactionId";
export const CANCEL_TRANSACTION_URL =
  "/payment/initialize/api/cancel/:transactionId";
